import { UPSELL_HOME_CARD_SNOOZE_HOURS } from 'fym-shared/src/music24/watermarkUpsell';
import type { UpsellTrialPhase } from './trialPhase';

const HOUR_MS = 60 * 60 * 1000;

function storageKey(userId: number): string {
  return `m24.upsell.homeCard.later.${userId}`;
}

interface StoredSnooze {
  until: number;
  phase: UpsellTrialPhase;
}

function readSnooze(userId: number): StoredSnooze | null {
  try {
    const raw = window.localStorage.getItem(storageKey(userId));
    if (raw === null) {
      return null;
    }
    const value: unknown = JSON.parse(raw);
    if (typeof value !== 'object' || value === null) {
      return null;
    }
    const { until, phase } = value as Record<string, unknown>;
    if (typeof until !== 'number' || (phase !== 'running' && phase !== 'lastDay' && phase !== 'free')) {
      return null;
    }
    return { until, phase };
  } catch (error) {
    // A browser that blocks the storage: the card shows.
    console.error(error);
    return null;
  }
}

/**
 * "Later" on the Home card (design: trial-upsell b2) hides it for 48 hours, on this device, for
 * this user. The card comes back in the next phase (the last day, then Free): a "Later" of an
 * older phase does not hide it.
 */
export function isHomeCardSnoozed(userId: number | null, phase: UpsellTrialPhase, now: number): boolean {
  if (userId === null) {
    return false;
  }
  const snooze = readSnooze(userId);
  return snooze !== null && snooze.phase === phase && snooze.until > now;
}

export function snoozeHomeCard(userId: number | null, phase: UpsellTrialPhase, now: number): void {
  if (userId === null) {
    return;
  }
  try {
    const value: StoredSnooze = { until: now + UPSELL_HOME_CARD_SNOOZE_HOURS * HOUR_MS, phase };
    window.localStorage.setItem(storageKey(userId), JSON.stringify(value));
  } catch (error) {
    // The card hides for this page view only.
    console.error(error);
  }
}
